import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchGetCoeurs(action) {
	try {
		const result = yield fromApi.coupdecoeurGets(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_COEURS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* watchPostCoeurs(action) {
	try {
		const result = yield fromApi.coupdecoeurPost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_COEUR_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* watchGetCoeur(action) {
	try {
		const result = yield fromApi.coupdecoeurGet(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_COEUR_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* watchPutCoeur(action) {
	try {
		const result = yield fromApi.coupdecoeurPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_COEUR_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* watchPutCoeurStatut(action) {
	try {
		const result = yield fromApi.coupdecoeurStatutPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_COEURSTATUT_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* watchDelCoeur(action) {
	try {
		const result = yield fromApi.coupdecoeurDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_COEUR_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* coeurs() {
	yield takeLatest('GET_COEURS_SAGAS', watchGetCoeurs);
	yield takeLatest('POST_COEUR_SAGAS', watchPostCoeurs);
	yield takeLatest('GET_COEUR_SAGAS', watchGetCoeur);
	yield takeLatest('PUT_COEUR_SAGAS', watchPutCoeur);
	yield takeLatest('PUT_COEURSTATUT_SAGAS', watchPutCoeurStatut);
	yield takeLatest('DEL_COEUR_SAGAS', watchDelCoeur);
}

export default function* rootSaga() {
	yield all([coeurs()]);
}
